var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":_vm.src}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }